import React, { useEffect, useRef, useState } from "react";
import { RangeSlider } from 'rsuite';
import "../opportunities/opportunitySlider.scss";

const NextTierSlider = (props: any) => {
  const leftPivot = props.leftPivot > 120 ? 120 : props.leftPivot;
  const rightPivot = props.rightPivot;
  const rebateData = props.rebate;
  const points = [
    80, 85, 90, 95, 100, 102.5, 105, 107.5, 110, 112.5, 115, 117.5, 120, 122.5
  ];

  const [value, setValue] = useState<[number, number]>([
    leftPivot <= 70 ? 75 : leftPivot,
    rightPivot,
  ]);

  useEffect(() => {
    setValue([leftPivot <= 70 ? 75 : leftPivot,
    props.rightPivot])
  }, [props.rightPivot, rebateData])

  const renderMark = (markValue: number) => {
    if ([70].includes(markValue)) {
      return (
        <div style={{ marginTop: "-2.2vh", marginLeft: "-17px" }}>
          <span
            style={{
              marginLeft: ".7vw",
              display: "inline-block",
              transform: "translateX(-50%)",
            }}
          >
            0%
          </span>
          <div className='devider'>|</div>
        </div>
      );
    } else if (leftPivot > 0 && leftPivot <= 70 && [75].includes(markValue)) {
      return (
        <div style={{ marginTop: "-2.2vh", marginLeft: "-17px" }}>
          <span
            style={{
              marginInline: "1vh",
              display: "inline-block",
              transform: "translateX(-50%)",
            }}
          >{Number(leftPivot).toFixed(2)}%
          </span>
          <div className='devider'>|</div>
        </div>
      );
    } else if ([120].includes(markValue)) {
      return (
        <div style={{ marginTop: "-2.2vh", marginLeft: "-17px" }}>
          <span
            style={{
              marginInline: "1vh",
              display: "inline-block",
              transform: "translateX(-50%)",
            }}
          >
            120+%
          </span>
          <div className='devider'>|</div>
          <div style={{ marginTop: "2vh" }}>{Number(`${rebateData?.[`${markValue.toFixed(2)}%`] * 100}`).toFixed(2) + '%'}</div>
        </div>
      );
    } else if (points.includes(markValue)) {
      return (
        <div style={{ marginTop: "-2.2vh", marginLeft: "-17px" }}>
          <span
            style={{
              marginInline: "1vh",
              display: "inline-block",
              transform: "translateX(-50%)",
            }}
          >
            {markValue}%
          </span>
          <div className='devider'>|</div>
          <div style={{ marginTop: "2vh" }}>{Number(`${rebateData?.[`${markValue.toFixed(2)}%`] * 100}`).toFixed(2) + '%'}</div>
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <div className={`nextTier_slider-wrapper nextTier_slider`}>
        <div className="flex flex-col static-block">
          <div className="flex justify-between w-[100%] h-full items-center">
            <span className="w-full text-center">Supplier</span>
            <span>
              Base <br /> Rebate
            </span>
          </div>
          <div className="vendor_section">
            <span>
              {rebateData?.master_vendor_name}
            </span>
            <span className="text-center left-2">
              {(rebateData?.rebate_base * 100).toFixed(2)}%
            </span>
          </div>
        </div>

        <RangeSlider
          min={70}
          defaultValue={value}
          step={2.5}
          max={122.5}
          graduated
          progress
          value={value}
          handleClassName={`triangle-handle ${props.leftPivot > 120 ? 'hide-greenHandle' : ''}`}
          // onChange={handleSliderChange}
          // constraint={([start, end]) => {
          //   const l = leftPivot <= 70 ? 75 : leftPivot;
          //   return start == l && end > l && end >= 80;
          // }}
          renderMark={renderMark}
          renderTooltip={(markValue: any) => {
            if ([80].includes(markValue)) {
              return <span>0%</span>;
            } else if (leftPivot <= 70 && [75].includes(markValue)) {
              return <span>{Number(leftPivot).toFixed(2)}%</span>;
            } else if ([120].includes(markValue)) {
              return <span>{props.leftPivot > 120? (props.leftPivot).toFixed(2) :markValue}%</span>;
            } else if (points.includes(markValue)) {
              return <span>{markValue}%</span>;
            } /* (leftPivot > 70) */ else {
              return <span>{Number(leftPivot).toFixed(2)}%</span>;
            }
          }}
          style={{ width: "100%" }}
          className="m-4"
        />

      </div>
    </>
  );
};

export default NextTierSlider;
